import { render, staticRenderFns } from "./SupplierCategoryModal.vue?vue&type=template&id=65c18cfb&scoped=true"
import script from "./SupplierCategoryModal.vue?vue&type=script&lang=js"
export * from "./SupplierCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierCategoryModal.vue?vue&type=style&index=0&id=65c18cfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c18cfb",
  null
  
)

export default component.exports